"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Tag: function() {
        return _index.Tag;
    },
    renderTag_unstable: function() {
        return _index.renderTag_unstable;
    },
    tagClassNames: function() {
        return _index.tagClassNames;
    },
    useIconStyles: function() {
        return _index.useIconStyles;
    },
    useMediaStyles: function() {
        return _index.useMediaStyles;
    },
    usePrimaryTextStyles: function() {
        return _index.usePrimaryTextStyles;
    },
    useSecondaryTextBaseClassName: function() {
        return _index.useSecondaryTextBaseClassName;
    },
    useTagStyles_unstable: function() {
        return _index.useTagStyles_unstable;
    },
    useTag_unstable: function() {
        return _index.useTag_unstable;
    }
});
const _index = require("./components/Tag/index");
